import { ISchemaInput, ISIBare, ISIConst, ISIEnum, NestedSchema, RootSchema, TD } from '../union';
import { IsNever, SchemaTypeName } from './core';
import { ISchemaNumber } from './number.types';

export * from './number.types';

/**
 * Property value is a number or array of numbers
 */
export function number<EnumVal extends TD<ISchemaNumber>>(
    schema: RootSchema<ISchemaInput<ISchemaNumber, ISIEnum<ISchemaNumber, EnumVal>>>
): ISchemaNumber<EnumVal>;
export function number<EnumVal extends TD<ISchemaNumber>>(
    schema: NestedSchema<ISchemaInput<ISchemaNumber, ISIEnum<ISchemaNumber, EnumVal>>>
): NestedSchema<ISchemaNumber<EnumVal>>;
export function number<ConstVal extends TD<ISchemaNumber>>(
    schema: RootSchema<ISchemaInput<ISchemaNumber, ISIConst<ISchemaNumber, ConstVal>>>
): ISchemaNumber<ConstVal>;
export function number<ConstVal extends TD<ISchemaNumber>>(
    schema: NestedSchema<ISchemaInput<ISchemaNumber, ISIConst<ISchemaNumber, ConstVal>>>
): NestedSchema<ISchemaNumber<ConstVal>>;
export function number(
    schema: RootSchema<ISchemaInput<ISchemaNumber, ISIBare<ISchemaNumber>>>
): RootSchema<ISchemaNumber>;
export function number(
    schema: NestedSchema<ISchemaInput<ISchemaNumber, ISIBare<ISchemaNumber>>>
): NestedSchema<ISchemaNumber>;
export function number(schema: ISchemaInput<ISchemaNumber>): ISchemaNumber {
    return {
        type: SchemaTypeName.number,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = number({ description: '', $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = number({ description: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
